import {Component, computed, effect, input, output, signal, WritableSignal} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {FontAwesomeCode} from "@models";

@Component({
	selector: "sim-button-segment",
	imports: [MatIcon],
	templateUrl: "./button-segment.component.html",
	styleUrl: "./button-segment.component.scss",
})
export class ButtonSegmentComponent {
	public readonly icon = input.required<FontAwesomeCode>();
	public readonly disabled = input<boolean>(false);
	public readonly onClick = output<void>();

	readonly #index = signal(0);
	#activeSegment: WritableSignal<number> | null = null;

	public registerClickListener(index: number, activeIndex: WritableSignal<number>): void {
		this.#activeSegment = activeIndex;
		this.#index.set(index);
	}

	protected isActive = computed(() => this.#activeSegment?.() === this.#index());

	protected handleClick(): void {
		this.#activeSegment?.set(this.#index());
	}

	readonly #activityStateChanged = effect(() => {
		const isActive = this.isActive();
		if (isActive) {
			this.onClick.emit();
		}
	});
}
